/**
 * Mercado Pago vinculado por OAuth: cuentas, transferencias recibidas y tablet pública del
 * kiosko (`docs/api/mercadopago.md`).
 */
import { z } from "zod";
import { MP_ACCOUNT_PURPOSES, MP_TRANSFER_STATUSES } from "../enums.js";
import { dateOnly, objectId, pagination, reasonRequired } from "./base.js";
export const mpPurposeParams = z.object({ purpose: z.enum(MP_ACCOUNT_PURPOSES) });
/** Desvincular exige motivo, como revocar una credencial (D5). */
export const mpUnlinkBody = z.object({ reason: reasonRequired });
/**
 * Lo que MP manda al callback de OAuth. `error` llega cuando el usuario no autorizó; los
 * demás campos pueden faltar, así que todos son opcionales y el servicio decide.
 */
export const mpOAuthCallbackQuery = z.object({
    code: z.string().trim().max(500).optional(),
    state: z.string().trim().max(200).optional(),
    error: z.string().trim().max(200).optional(),
});
export const mpTransfersQuery = pagination.extend({
    status: z.enum(MP_TRANSFER_STATUSES).optional(),
    /** Nombre, email o documento del que transfirió. */
    q: z.string().trim().min(1).max(120).optional(),
    from: dateOnly.optional(),
    to: dateOnly.optional(),
});
export const mpReconcileBody = z.object({
    memberId: objectId,
    chargeIds: z.array(objectId).min(1).max(24),
});
export const mpIgnoreBody = z.object({ reason: reasonRequired });
// ── Tablet pública del kiosko ────────────────────────────────────────────────
export const kioskStorefrontsQuery = z.object({ branchId: objectId.optional() });
export const createKioskStorefrontBody = z.object({
    branchId: objectId,
    name: z.string().trim().min(2).max(60),
});
export const revokeKioskStorefrontBody = z.object({ reason: reasonRequired });
/** El token del link público: 32 bytes en base64url (43 caracteres). */
export const tiendaTokenParams = z.object({
    token: z.string().regex(/^[A-Za-z0-9_-]{20,100}$/, "Link inválido"),
});
export const tiendaOrderParams = tiendaTokenParams.extend({ id: objectId });
/** El cliente manda qué y cuánto; el precio sale SIEMPRE del catálogo (RN-CON-23). */
export const tiendaCreateOrderBody = z.object({
    items: z
        .array(z.object({ productId: objectId, qty: z.number().int().min(1).max(20) }))
        .min(1)
        .max(30),
});
//# sourceMappingURL=mercadopago.js.map